import RegisterDeviceView from "./view";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useNavigate } from "react-router-dom";
import {
  sendPinRegisterDevice,
  setCustomer,
  validatePinRegisterDevice,
} from "@/redux/ducks/customer";

export default function RegisterDevice() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector(
    (
      state: ReducersTypes & {
        customerReducer: {
          pinDevice: string;
        };
      },
    ) => state.customerReducer,
  );
  const TIME_AGAIN = 1000;

  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [pinAgain, setPinAgain] = useState(false);
  const [error, setError] = useState(false);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    dispatch(setCustomer({ pinDevice: value }));
  };

  const getIsDisabled = () => {
    if (customer?.pinDevice?.length < 5) return true;
    return false;
  };

  const handleSendPin = () => {
    if (isLoading) return;

    setIsLoading(true);

    dispatch(
      sendPinRegisterDevice({
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        callback: (_) => {
          setIsLoading(false);
        },
      }),
    );
  };

  const handleValidatePin = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage) setError(true);
    }
  };

  const handleSubmit = () => {
    if (isLoading || getIsDisabled()) return;

    setIsLoading(true);
    setError(false);

    dispatch(
      validatePinRegisterDevice({
        pin: customer?.pinDevice,
        callback: handleValidatePin,
      }),
    );
  };

  const handleTryAgain = () => {
    if (timer !== 0 || isLoading) return;
    setIsLoading(true);
    setTimer(30);
    handleSendPin();
  };

  const updateCount = useCallback(() => {
    if (timer > 0) {
      setTimeout(() => {
        setTimer(timer - 1);
      }, TIME_AGAIN);
    }
  }, [timer]);

  useEffect(() => {
    if (timer !== 0) {
      updateCount();
      if (!pinAgain) setPinAgain(true);
    } else if (pinAgain) setPinAgain(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer, setPinAgain, updateCount]);

  useEffect(() => {
    if (error) setError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.pinDevice]);

  useEffect(() => {
    dispatch(setCustomer({ pinDevice: "" }));
    handleSendPin();
    updateCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegisterDeviceView
      handleTryAgain={handleTryAgain}
      timer={timer}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      pin={customer?.pinDevice}
      onChange={onChange}
      error={error}
      goBack={goBack}
      isDisabled={getIsDisabled()}
    />
  );
}
